import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";


import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { checkCHKLDDModificationEligibility, currentPaymentMoodeMapping, getConditionalReferenceNumber, nonEligiblePayModeChange, paymentModeMapping } from "../constant";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { getPaymentModeName } from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";
import {ReactComponent as EditIcon} from "assets/img/svg/EditBlackIcon.svg"
import { findPaymentModeKey } from "views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant";
import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";
import moment from "moment";
import { getPaymentInfo } from "../utils";
import PaymentModeChangeAlertDialog from "./PaymentModeChangeAlertDialog";



const ModifyPaymentListing = forwardRef(
  (
    {
      loader,
      rowList=[],
      totalPaidAmount,
      setIsEditModeModal,
      contextValue,
      setRowId,
      setOldPaymentMode,
      setPaymentModeCollectionDetailsId
    },
    ref
  ) => {

    // const {setCurrentPaymentMode}= usePaymentCollectionReceiptContext()

    const [modeChangeDilogInfo , setModeChangeDialogInfo] = useState({isOpen : false , rowData : {}});

    const {setCurrentPaymentMode,modifyPaymentModeData,setPaymentModeForm,setBalanceAmount,studentBasicDetails,setNoAmountChange,setStudentBasicDetails,collectPayment,setCollectPayment}=contextValue
    const editHandler=(newPaymentObj)=>{
      let tempList=[]
      for(let i in collectPayment){
        if(collectPayment[i]?.referenceNumber!=newPaymentObj?.referenceNumber){
          tempList=[...tempList,collectPayment[i]]}
      }
      setCollectPayment(tempList)
    }
const selectHandler=async (params)=>{

  // if(checkCHKLDDModificationEligibility(params?.row)){

  if(params?.row?.isPaymentModeChangeEligible){

  setStudentBasicDetails((prev)=>({...prev,oldReferenceNumber:params?.row?.referenceNumber,oldPaymentMode:params?.row?.paymentMode}))

  const paymentInfo = await getPaymentInfo(studentBasicDetails,params?.row)

  const formObj={paidAmount:(+params?.row?.paidAmount).toFixed(2),
    paymentMode:params?.row?.paymentMode,
    referenceNumber:getConditionalReferenceNumber(params?.row?.referenceNumber,params?.row?.paymentMode),
    paymentModeDescription: paymentInfo?.paymentModeDescription,
    paymentModeDate:params?.row?.paymentModeDate&&moment(params?.row?.paymentModeDate),
    bank:{label:paymentInfo?.bankName, value:paymentInfo?.bankName,id:paymentInfo?.bankMasterId},
    paymentModeAttachmentS3Key: paymentInfo?.paymentModeAttachmentS3Key,
    gatewayName: paymentInfo?.gatewayName,
    cardType: {label:paymentInfo?.cardType,value:paymentInfo?.cardType},
    firstName: paymentInfo?.firstName,
    lastName: paymentInfo?.LastName,
    onlineSale: {label:paymentInfo?.onlineSale, value:paymentInfo?.onlineSale},
    fileName: paymentInfo?.fileName,
  }

  setCurrentPaymentMode(findPaymentModeKey(params?.row?.paymentMode)??params?.row?.paymentMode)
  setIsEditModeModal(true);
  setOldPaymentMode(params?.row?.paymentMode)
  setRowId(params?.row?.id)
  setBalanceAmount(params?.row?.paidAmount)
  setPaymentModeForm((prev)=>({...prev,
    ...formObj
  }))
  setStudentBasicDetails((prev)=>({...prev,courseId:params?.row?.courseId}))
  setNoAmountChange(true)
}
else{
  failureToast(params?.row?.nonEligibleReason)
}
// }
// else{
// failureToast('Only In hand cheque or DD payment mode change is allowed')
// }
}

const newPaymentModeNameHandler=(payModeKey)=>{
 return <><span>{getPaymentModeName(paymentModeMapping[payModeKey])??getPaymentModeName(payModeKey)} </span> <EditIcon/> </>
}
    const columns = [
      new AGridColDef("paymentMode", "Old Payment Mode", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <Tooltip title={getPaymentModeName(params?.value)}>
            <div className={`ellipsis-text-container`}>{getPaymentModeName(params?.value)??params?.value}</div>
          </Tooltip> : <div>-</div>
        )),
        new AGridColDef("action", "New Payment Mode", false)
        .setMinWidth(80)
        .editable(true)
        .setFlex(0.5)
        .columnAlign('left')
        .renderCellComponent((params) => (
         modifyPaymentModeData?.[params?.row?.id]?
         <div
         className="d-flex align-items-center justify-content-start"
         style={{gap:'10px'}}
          onClick={()=>{
              setIsEditModeModal(true);
              setBalanceAmount(params?.row?.paidAmount)
              setCurrentPaymentMode(modifyPaymentModeData?.[params?.row?.id].paymentMode)
              setPaymentModeForm(modifyPaymentModeData?.[params?.row?.id])
              setRowId(params?.row?.id)
              editHandler(modifyPaymentModeData?.[params?.row?.id])
          }}
      >
          {newPaymentModeNameHandler(modifyPaymentModeData?.[params?.row?.id].paymentMode)}
        
      </div>
      
         : <AButton
          variant={"primary_filled"}
          disabled={nonEligiblePayModeChange.includes((params?.row?.paymentMode).toUpperCase())|| params?.row?.paidAmount<0}
          size='xs'
          className='btn-left-0'
          onClick={()=>{
            setPaymentModeCollectionDetailsId(params?.row?.paymentModeCollectionDetailsId)
            Object.keys(modifyPaymentModeData).length==0 
            // ? selectHandler(params)
            ? setModeChangeDialogInfo({isApiCall : true , rowData : {...params , paymentMode : params?.row?.paymentMode , paymentTransactionId : params?.row?.referenceNumber, ...studentBasicDetails}})
            : failureToast("At a time user can modify only one payment mode")
          }}
      >
          Select
      </AButton>
        )),
        new AGridColDef("paidAmount", "Amount", false)
        .setMinWidth(60)
        .editable(true)
        .columnAlign('right')
        .setFlex(0.5)
        .renderCellComponent((params) => (
          (params?.value|| Number(params?.value)==0) ? <Tooltip title={formattedPrice(params?.value)}>
            <div className={`ellipsis-text-container`}>{formattedPrice(params?.value)}</div>
          </Tooltip> : <div>-</div>
        )),
    ];

    return (<>
      <div className="" style={{border:'1px solid #EEE', borderRadius:'8px'}}>
        <ADataGrid
          removeWrapperContainer
          rowModesModel
          rows={rowList || []}
          columns={columns}
          rowId={(row) => row?.id}
          rowHeight={50}
          rowCount={rowList.length}
          loading={false}
          components={{
            ...gridComponents,
            NoRowsOverlay: () => (
              <NoRowOverlay message={loader ? "Loading..." : null} />
            ),
          }}
          sx={{
            ...gridStyles,
          }}
          autoHeight
          hidePagination={true}
        />
      </div>
      <div className="d-flex justify-content-between align-items-center large-semi-bold" style={{marginTop:'16px'}}>
          <span className="label-color">
              Total Amount Paid
          </span>
          <span style={{color:'#07794C'}}>
              {formattedPrice(totalPaidAmount)}
          </span>
      </div>

      <PaymentModeChangeAlertDialog
      dialogInfo={modeChangeDilogInfo}
      setDialogInfo={setModeChangeDialogInfo}
      confirmHandler={selectHandler}
      key={modeChangeDilogInfo?.isApiCall}
      />

      </>
    );
  }
);
export default ModifyPaymentListing;
